import { DeviceViewModel, TriggerLocationViewModel } from "@/TemsManagerWebInterface";
import Localization from "@/Localization";
import TemsWebEvents from "@/TemsWebEvents";
import SliderControl from "./SliderControl";

export default class TriggerControl {
    
    private content: JQuery;
    private posTriggers: JQuery;
    private negTriggers: JQuery;
    private posAddButton: JQuery;
    private negAddButton: JQuery;
    private isInEditMode: boolean;

    constructor(deviceModel: DeviceViewModel, isInEditMode: boolean) {
        this.isInEditMode = isInEditMode;
        this.createTriggerControl(deviceModel);
    }

    // TODO rework that we actually have slider handles... not this finding stuff by css selectors..
    //        private assignedSliders: { [id: string]: SliderControl } = {};
    //        private unassignedPosSliders: SliderControl[] = [];
    //        private unassignedNegSliders: SliderControl[] = [];

    public get Content() {
        return this.content;
    }

    public get TriggerLocations() {
        let newTriggerLocations = [];
        function handle($el) {
            if ($el) {
                $el.find("input.siteTreeSlider").each((idx, sliderElement) => {
                    const elem = $(sliderElement);
                    if (elem.slider("isEnabled")) {
                        const sliderValue = elem.slider("getValue");
                        newTriggerLocations.push({ Location: sliderValue, Id: elem.parent().parent().parent().data("triggerid") });// TODO refactoring that doesn't need the p().p().p() would be nice
                    }
                });
            }
        }
        handle(this.negTriggers);
        handle(this.posTriggers);

        return newTriggerLocations;
    }

    private createTriggerControl(deviceModel: DeviceViewModel) {
        this.content = $("<div>", { "class": "triggerControl" });

        if (deviceModel.TriggerSettings.MaximalNegativeTriggers > 0) {
            let negativeTriggers = this.buildTriggerControl(
                deviceModel,
                true,
                `sitetree-element-negative-triggers-${deviceModel.Id}`,
                deviceModel.TriggerSettings.MaximalNegativeTriggers,
                deviceModel.TriggerSettings.FarthestNegativeTriggerPosition,
                deviceModel.TriggerSettings.ClosestNegativeTriggerPosition,
                deviceModel.TriggerSettings.ClosestNegativeTriggerPosition
            );
            this.content.append(negativeTriggers);
        }

        this.content.append($(`<span class="triggerControlGantry">`)); // bar that represents the gantry

        if (deviceModel.TriggerSettings.MaximalPositiveTriggers > 0) {
            let positiveTriggers = this.buildTriggerControl(
                deviceModel,
                false,
                `sitetree-element-positive-triggers-${deviceModel.Id}`,
                deviceModel.TriggerSettings.MaximalPositiveTriggers,
                deviceModel.TriggerSettings.ClosestPositiveTriggerPosition,
                deviceModel.TriggerSettings.FarthestPositiveTriggerPosition,
                deviceModel.TriggerSettings.ClosestPositiveTriggerPosition
            );
            this.content.append(positiveTriggers);
        }

        return this.content;
    }

    private buildTriggerControl(deviceModel: DeviceViewModel, negativeTrigger: boolean, domId: string, maxNrOfTriggers: number, min: number, max: number, defaultLocation: number): JQuery {
        let control = $("<span>", { "id": domId, "class": "flexGrow1" });
        const triggerAddButton = $("<span>", { id: `${domId}-addButton`, "class": "glyphicon glyphicon-plus editControl control-inline" }).click(() => {
            // how many already active?
            let activeCount = control.find(".slider:not(.slider-disabled)").length;
            if (activeCount < maxNrOfTriggers) {
                this.setTriggerValue(deviceModel, negativeTrigger, activeCount, { Id: undefined, Location: defaultLocation });
                TemsWebEvents.publishEvent(TemsWebEvents.TriggerLinesChanged, [deviceModel.Id]);
                activeCount++;
            }
        });

        control.append(
            $("<div>")
                .html(negativeTrigger ? Localization.resourceStrings.TriggerControl_TabHeaderBack : Localization.resourceStrings.TriggerControl_TabHeaderFront)
                .append(triggerAddButton)
        );

        if (negativeTrigger) {
            this.negTriggers = control;
            this.negAddButton = triggerAddButton;
        } else {
            this.posTriggers = control;
            this.posAddButton = triggerAddButton;
        }

        return control;
    }

    public updateTriggerButton(deviceModel: DeviceViewModel, isInEditMode: boolean) {
        if (deviceModel.TriggerSettings) {
            this.content.find(".removeMe").remove();

            const serverState = deviceModel.TriggerLocations.map(x => x.Location).join();
            const knownState = this.content.data("serverstate");

            if (serverState !== knownState) {

                this.content.data("serverstate", serverState);

                const positiveTriggers = deviceModel.TriggerLocations.filter(x => x.Location > 0.0);
                const negativeTriggers = deviceModel.TriggerLocations.filter(x => x.Location < 0.0);

                for (let i = 0, len = positiveTriggers.length; i < len; i++) {
                    const trigger = positiveTriggers[i];
                    this.setTriggerValue(deviceModel, false, i, trigger);
                }

                for (let i = 0, len = negativeTriggers.length; i < len; i++) {
                    const trigger = negativeTriggers[i];
                    this.setTriggerValue(deviceModel, true, i, trigger);
                }

                if (this.posAddButton) {
                    this.posAddButton.toggle(isInEditMode && positiveTriggers.length < deviceModel.TriggerSettings.MaximalPositiveTriggers);
                }

                if (this.negAddButton) {
                    this.negAddButton.toggle(isInEditMode && negativeTriggers.length < deviceModel.TriggerSettings.MaximalNegativeTriggers);
                }
            }
        }
    }

    private addTriggerSlider(triggerControl: JQuery, deviceModel: DeviceViewModel, negativeTrigger: boolean) {
        const min = negativeTrigger ? deviceModel.TriggerSettings.FarthestNegativeTriggerPosition : deviceModel.TriggerSettings.ClosestPositiveTriggerPosition;
        const max = negativeTrigger ? deviceModel.TriggerSettings.ClosestNegativeTriggerPosition : deviceModel.TriggerSettings.FarthestPositiveTriggerPosition;
        const deviceId = deviceModel.Id;

        const container = $("<span>", { "class": "triggerSliderContainer" });

        const triggerRemoveButton = $("<span>", { "class": "glyphicon glyphicon-trash editControl control-inline", "style": "align-self:center;" }).click(() => {
            container.find("input").slider("disable");
            container.addClass("removeMe");
            TemsWebEvents.publishEvent(TemsWebEvents.TriggerLinesChanged, [deviceId]);
        });

        let slider = new SliderControl("", min, max, 0.1, "m", (id, newValue) => { TemsWebEvents.publishEvent(TemsWebEvents.TriggerLinesChanged, [id]); }, deviceId, "", this.isInEditMode); //`${domId}-${i}`);
        slider.setValue(0.0, Localization.formatNumber1Digit);
        slider.Content.addClass("editControlVisible");
        container.append(slider.Content);

        if (negativeTrigger) {
            container.children("span").prepend(triggerRemoveButton);
        } else {
            container.children("span").append(triggerRemoveButton);
        }

        triggerControl.append(container);
    }

    public setTriggerValue(deviceModel: DeviceViewModel, isNegativeTrigger: boolean, triggerNr: number, trigger: TriggerLocationViewModel) {
        const triggerControl = isNegativeTrigger ? this.negTriggers : this.posTriggers;
        while (triggerControl.find(".triggerSliderContainer").length - 1 < triggerNr) {
            this.addTriggerSlider(triggerControl, deviceModel, isNegativeTrigger);
        }

        // find the known instance..
        let triggerToSet = triggerControl.find(".triggerSliderContainer").filter((idx, elem) => $(elem).data("triggerid") === trigger.Id);
        if (triggerToSet.length === 0) {
            // or get the first 'open' instance (the one that must have been created by the addTriggerSlider)
            triggerToSet = triggerControl.find(".triggerSliderContainer").filter((idx, elem) => !$(elem).data("triggerid")).first();
        }

        triggerToSet.find("input").slider("setValue", trigger.Location);
        triggerToSet.find(".siteEditable").editable("setValue", Localization.formatNumber1Digit(trigger.Location));

        triggerToSet.data("triggerid", trigger.Id);
    }
}
